(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["ta-SG"] = {
            name: "ta-SG",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Singapore Dollar",
                    abbr: "SGD",
                    pattern: ["-$ n","$ n"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "$"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["ஞாயிறு","திங்கள்","செவ்வாய்","புதன்","வியாழன்","வெள்ளி","சனி"],
                        namesAbbr: ["ஞாயி.","திங்.","செவ்.","புத.","வியா.","வெள்.","சனி"],
                        namesShort: ["ஞா","தி","செ","பு","வி","வெ","ச"]
                    },
                    months: {
                        names: ["ஜனவரி","பிப்ரவரி","மார்ச்","ஏப்ரல்","மே","ஜூன்","ஜூலை","ஆகஸ்ட்","செப்டம்பர்","அக்டோபர்","நவம்பர்","டிசம்பர்"],
                        namesAbbr: ["ஜன.","பிப்.","மார்.","ஏப்.","மே","ஜூன்","ஜூலை","ஆக.","செப்.","அக்.","நவ.","டிச."]
                    },
                    AM: ["முற்பகல்","முற்பகல்","முற்பகல்"],
                    PM: ["பிற்பகல்","பிற்பகல்","பிற்பகல்"],
                    patterns: {
                        d: "d/M/yyyy",
                        D: "dddd, d MMMM, yyyy",
                        F: "dddd, d MMMM, yyyy tt h:mm:ss",
                        g: "d/M/yyyy tt h:mm",
                        G: "d/M/yyyy tt h:mm:ss",
                        m: "d MMMM",
                        M: "d MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "tt h:mm",
                        T: "tt h:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy",
                        Y: "MMMM yyyy"
                    },
                    "/": "/",
                    ":": ":",
                    firstDay: 0
                }
            }
        };
    })();

}));
